import React, { Fragment, useEffect } from 'react';
import { Trans } from 'react-i18next';
import Table from 'src/components/Table';
import { useData } from './hooks';
import { useData as useMDData } from '../MasterDataManagerDashboard/hooks';
import s from '../Dashboards.styles';
import { MasterDataManagerColumns as columns } from '../MasterDataManagerDashboard/tableColumns/MasterDataManagerColumns';
import {
  UsersManagerColumns as userColumns,
  setUsers,
} from './tableColumns/UsersManagerColumns';

const AdministratorDashboard = () => {
  const [
    { data, loading, refetch, variables },
    { onPageChanged },
  ] = useMDData();
  const [
    {
      data: usersData,
      loading: usersLoading,
      refetch: usersRefetch,
      variables: usersVariables,
      users,
    },
    { onPageChanged: usersOnPageChanged },
  ] = useData();

  useEffect(() => {
    setUsers(users);
  }, [users]);
 
  return (
    <Fragment>
      <s.DashboardComponent>
        <s.DashboardComponentTitle>
          <Trans>MASTER_DATA_LAST_CHANGES</Trans>
        </s.DashboardComponentTitle>
        <Table
          name="MasterDataManagerDashboardGrid"
          gridColumns={columns()}
          data={!loading ? data.items : []}
          loading={loading}
          totalCount={data?.pageInfo?.totalCount}
          refetch={refetch}
          variables={variables}
          header={() => null}
          hideDeletedButton={true}
          onPageChanged={onPageChanged}
          paginationUseQuery={false}
        />
      </s.DashboardComponent>

      <s.DashboardComponent>
        <s.DashboardComponentTitle>
          <Trans>USERS_LAST_CHANGES</Trans>
        </s.DashboardComponentTitle>
        <Table
          name="UsersManagerDashboardGrid"
          gridColumns={userColumns()}
          data={!usersLoading ? usersData.items : []}
          loading={usersLoading}
          totalCount={usersData?.pageInfo?.totalCount}
          refetch={usersRefetch}
          variables={usersVariables}
          header={() => null}
          hideDeletedButton={true}
          onPageChanged={usersOnPageChanged}
          paginationUseQuery={false}
        />
      </s.DashboardComponent>
    </Fragment>
  );
};

export default React.memo(AdministratorDashboard);
